import React from 'react';
import { useLocation  } from 'react-router-dom';
import { Button, Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PaperCard } from 'components/Card';
import { paths } from 'routes';
import { useAuth } from 'lib/auth';
import { AuthLayout } from '../components/AuthLayout';

export const AccessRequested = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { state } = useLocation();
  
  const confirmationRequired = state;
  return (
  <>
    { !confirmationRequired && (
      <Stack
        minHeight="100vh"
        width="100%"
        bgcolor="#d9d9d9"
        justifyContent="center"
        position="absolute"
        zIndex={3}
      >
        <Box display="flex" justifyContent="center" alignItems="center" height={1} px={{ xs: 3, sm: 0 }}>
          <PaperCard px={{ xs: 2, sm: 4 }} width={{ xs: 1, sm: 369 }} maxWidth={369} /* height={351} */ maxHeight={351} bgcolor="#fff" sx={{ my: 5 }}>
            <Stack>
              <Typography variant="h5" sx={{ mb: 1, textAlign: "center" }}>
                {t('website:auth.accessRequested.heading')}
              </Typography>
              <Stack sx={{ textAlign: 'center' }}>
                <Typography variant="body1">{t('website:auth.accessRequested.adminEmailSent')}</Typography>
                <Typography variant="body1">{t('website:auth.accessRequested.approvalNotice')}</Typography>
              </Stack>
              <Stack>
                <Button
                  size="large"
                  variant="contained"
                  color="primary"
                  sx={{
                    mt: 2,
                    mb: 0.5,
                    bgcolor: "primary.light",
                    '&:hover': {
                      backgroundColor: "primary.light",
                    },
                  }}
                  href={user ? paths.homepage : paths.logout}
                >
                  {t('website:auth.accessRequested.returnToHomeButton')}
                </Button>
              </Stack>
            </Stack>
          </PaperCard>
        </Box>
      </Stack>
      )}
      {confirmationRequired && (
        <AuthLayout title={t('website:auth.accessRequested.pageTitle')}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height={1}
            px={{ xs: 5, sm: 1 }}
            pb={{ xs: 2, sm: 0 }}
          >
            <PaperCard px={{ xs: 2, sm: 4 }} width={{ xs: 1, sm: 369 }} maxWidth={369} maxHeight={351} bgcolor="#fff" sx={{ my: 5 }}>
              <Stack>
                <Typography variant="h5" sx={{ mb: 0.5, textAlign: "center" }}>
                  {t('website:auth.accessRequested.heading')}
                </Typography>
                <Stack sx={{ textAlign: 'center' }}>
                  <Typography variant="body1">{t('website:auth.accessRequested.adminEmailSent')}</Typography>
                  <Typography variant="body1">{t('website:auth.accessRequested.additionalConfirmationEmailPrefix')}</Typography>
                  <Typography variant="body1">{t('website:auth.accessRequested.yourAddressSuffix')}</Typography>
                  <Typography variant="body1">
                    {t('website:auth.accessRequested.linkValidityNotice')}
                  </Typography>

                  <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2, mb: 0.5 }}
                    href={paths.homepage}
                  >
                    {t('website:auth.accessRequested.returnToHomeButton')}
                  </Button>
                </Stack>
              </Stack>
            </PaperCard>
          </Box>
        </AuthLayout>
      )}
      </>
  );
};
